  <div class="wccard mb-2 p-3 border-bottom">
    <div class="">
  <div class="shimmer-header">
    <div class="shimmer-avatar shimmer"></div>
    <div class="shimmer-lines">
      <div class="shimmer-line shimmer"></div>
      <div class="shimmer-line short shimmer"></div>
    </div>
    <div class="shimmer-buttons">
      <div class="shimmer-button shimmer"></div>
      <div class="shimmer-button shimmer"></div>
    </div>
  </div>

  <div class="shimmer-tags">
    <div class="shimmer-tag shimmer"></div>
    <div class="shimmer-tag shimmer"></div>
    <div class="shimmer-tag shimmer"></div>
  </div>

  <div class="shimmer-meta">
    <div class="shimmer-meta-left shimmer"></div>
    <div class="shimmer-meta-right shimmer"></div>
  </div>

  <div class="shimmer-content">
    <div class="shimmer-line shimmer"></div>
    <div class="shimmer-line shimmer"></div>
    <div class="shimmer-line shimmer"></div>
    <div class="shimmer-line short shimmer"></div>
  </div>
</div>

  </div>
